import './style.scss';
import { ListItem } from 'views/mutual/list';
import { ApplicationItemFragment } from 'views/utils/graphql/graphql';
import { NavLink } from 'react-router-dom';
import { PagePath, PagePathFactory } from 'constants/pagePath';
import { HistoryStatusIcon } from '../historyStatus';
import { formatPrice } from 'views/utils/converter';
import { ProductType } from 'constants/productType';
import { ApplyAssetType } from 'views/utils/enums';

export type RequestHistoryListItemProps = {
  itemIndex: number;
  application: ApplicationItemFragment;
};

const getSymbolDetailPath = (assetType: ApplyAssetType, symbol: string): string | null => {
  switch (assetType) {
    case ApplyAssetType.LeaseFund:
      return PagePathFactory.leaseFundSymbolDetail(symbol);
    case ApplyAssetType.ITExplanation:
    case ApplyAssetType.DomesticRealEstate:
      return PagePathFactory.domesticRealEstateItExplanationSymbolDetail(symbol);
    case ApplyAssetType.OverseasRealEstate:
      return PagePathFactory.overseasRealEstateSymbolDetail(symbol);
    default:
      return null;
  }
};

export const RequestHistoryListItem = (props: RequestHistoryListItemProps) => {
  const { itemIndex, application } = props;
  
  const symbolDetailPath = application.Linkable 
    ? getSymbolDetailPath(application.AssetType, application.Symbol)
    : null;
  
  const titleContent = symbolDetailPath ? (
    <NavLink to={symbolDetailPath}>{application.SymbolShortName}</NavLink>
  ) : (
    <>{application.SymbolShortName}</>
  );

  return (
    <ListItem className={`historyBody`} itemIndex={itemIndex}>
      <div className="historyBody_status">
        <HistoryStatusIcon status={application.Status} />
      </div>
      <div className="historyBody_title">
        {titleContent}
      </div>
      <div className="historyBody_amount">{formatPrice(application.ApplicationAmount) + application.Unit}</div>
      <div className="historyBody_date">{application.ApplicationDate}</div>
    </ListItem>
  );
};

export type RequestHistoryListProps = {
  items: Array<ApplicationItemFragment | null>;
};
export const RequestHistoryList = ({ items }: RequestHistoryListProps) => {
  return (
    <>
      {items
        ?.filter((x) => (x ? true : false))
        .map((item, index) => (
          <RequestHistoryListItem key={item?.ID} itemIndex={index} application={item!} />
        ))}
    </>
  );
};
